// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jg_a bhk_a bhk_j bhk_q bhk_st bhk_su bhk_w"};